import { render, staticRenderFns } from "./SimpleModuleForm.vue?vue&type=template&id=07b348fe&scoped=true&"
import script from "./SimpleModuleForm.vue?vue&type=script&lang=js&"
export * from "./SimpleModuleForm.vue?vue&type=script&lang=js&"
import style0 from "./SimpleModuleForm.vue?vue&type=style&index=0&id=07b348fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b348fe",
  null
  
)

export default component.exports